export const LsKeys = {
    paletteType: 'paletteType',
    signInRedirect: 'signInRedirect',
    access: 'access',
    refresh: 'refresh',
    user: 'user',
    organisations: 'organisations'
};